import * as _4 from 'lodash4';
require('./vendor.ts');
angular
  .module('capability-ng-appointments', [
    'ngSanitize',
    'ngAria',
    'utility-ng-enumeration',
    'utility-ng-interface',
    'ui-ng-delegate',
    'utility-ng-auth-token',
    'ui-ng-week-times',
    'ui-ng-content-tile',
    'ui-ng-app-content',
    'ui-ng-content-tabs',
    'ui-ng-navbar',
    'ui-ng-popup',
    'capability-ng-notification-settings'
  ])
  .value('appointmentCampaignConstant', {
    isAppointmentCampaign: false,
    campaignInvitationId: 0
  });

import './core';

export const APPOINTMENTS = 'capability-ng-appointments';

import './config/appointment_scheduling_configuration';

export * from './config/appointment_scheduling_configuration';
export * from './commands/alertnate_appointment_times_confirmation_command';
export * from './commands/appointment_scheduling_type_selected_command';
export * from './commands/appointments_confirm_command';
export * from './commands/appointments_confirmation_comand';
export * from './commands/appointments_course_selected_command';
export * from './commands/appointments_location_selected_command';
export * from './commands/appointments_service_category_selected_command';
export * from './commands/appointments_service_selected_command';
export * from './commands/appointments_staff_selected_command';
export * from './commands/appointments_time_selection_change_command';
export * from './commands/cancel_appointment';
export * from './commands/clear_all_appointments_datasources';
export * from './commands/clear_appointments_cache_on_server_command';
export * from './commands/load_appointment_type_configuration_service_command';
export * from './commands/load_appointments_available_times_command';
export * from './commands/load_appointments_locations_command';
export * from './commands/load_available_walkin_times_command';
export * from './commands/load_cancellation_reasons';
export * from './commands/load_upcoming_appointments';
export * from './commands/prepare_appointment_campaign_request';
export * from './commands/appointments_checkin_command';
export * from './commands/appointments_checkout_command';

export * from './components/scroll_content/scroll_content';
export * from './components/dead_end/dead_end';
export * from './components/appointment_card/appointment_card';
export * from './components/choice_selector/choice_selector';
export * from './components/appointments_link/appointments_link';

export * from './components/components_module';
export * from './components/dead_end/dead_end';
export * from './components/my_appointments/my_appointments';
export * from './datasources/cancellation_reasons_datasource';
export * from './datasources/datasources_module';
export * from './datasources/upcoming_appointments_datasource';
export * from './enums/appointments_tab_enum';
export * from './enums/enums_module';
export * from './enums/reminder_enum';
export * from './models/confirm_appointment_model';
export * from './queries/cancellation_reasons_query';
export * from './queries/queries_module';
export * from './queries/upcoming_appointments_query';
export * from './routes';
export * from './servants/appointment_info_servant';
export * from './servants/appointment_reminders_servant';
export * from './servants/appointments_available_times_servant';
export * from './servants/appointments_command_servant';
export * from './servants/appointments_confirm_servant';
export * from './servants/appointments_tabs_configuration';
export * from './servants/appointments_usersource_servant';
export * from './servants/current_user_appointments_servant';
export * from './servants/local_storage_servant';
export * from './servants/prepare_appointment_campaign_request_servant';
export * from './servants/servants_module';
export * from './services/my_appointment_state_service';
export * from './services/my_appointments_service';
export * from './services/services_module';
export * from './types/appointment_interfaces';
export * from './types/appt_interfaces';
export * from './usersources/alternate_appointment_times_usersource';
export * from './usersources/appointment_available_times_usersource';
export * from './usersources/appointment_location_staff_usersource';
export * from './usersources/appointment_reason_usersource';
export * from './usersources/usersources_module';
export * from './views/alternate_appointment_times/alternate_appointment_times';
export * from './views/alternate_appointment_times_confirm/alternate_appointment_times_confirm';
export * from './views/appointment_reason/appointment_reason';
export * from './views/appointments/appointments';
export * from './views/available_times/available_times';
export * from './views/confirm/confirm';
export * from './views/location_staff/appointments_location_staff';
export * from './views/my_appointments/my_appointments_children_controller';

export * from './views/appointments/appointments';
export * from './views/location_staff/appointments_location_staff';
export * from './views/available_times/available_times';
export * from './views/walkin_times/walkin_times';
export * from './views/walkin_times/walkin_times_controller';
export * from './views/alternate_appointment_times_confirm/alternate_appointment_times_confirm';
export * from './views/alternate_appointment_times/alternate_appointment_times';
export * from './views/confirm/confirm';
export * from './views/scheduled/scheduled';

export * from './views/views_module';
export * from './views/walkin_times/walkin_times';
export * from './views/walkin_times/walkin_times_controller';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/main.ts